import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';

import Icon from 'foundations/Icons/Icon';

import styles from './Tag.css';

class Tag extends Component {
  static propTypes = {
    name: PropTypes.string,
    disable: PropTypes.bool,
    active: PropTypes.bool,
    withClose: PropTypes.bool,
    secondary: PropTypes.bool,
    large: PropTypes.bool,
    small: PropTypes.bool,
    icon: PropTypes.object,
    customStyles: PropTypes.object,
    onSelect: PropTypes.func,
    onClose: PropTypes.func,
    id: PropTypes.number
  };

  state = {
    isActive: null,
    isClosed: false
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.active && (prevState.isActive === null)) {
      return {
        isActive: true
      };
    }

    return null;
  }

  handleSelect = e => {
    e.preventDefault();
    const { onSelect } = this.props;
    const { isActive } = this.state;

    this.setState({ isActive: !isActive });

    onSelect && onSelect(e);
  }

  handleClose = e => {
    e.preventDefault();
    const { onClose } = this.props;

    this.setState({ isClosed: true });

    onClose && onClose(e);
  }

  renderTag = () => {
    const {
      name,
      disable,
      withClose,
      icon,
      secondary,
      customStyles,
      id,
      large,
      small
    } = this.props;

    const {
      isActive,
      isClosed
    } = this.state;

    const cx = classnames.bind(styles);
    const classes = cx('tag',
      {
        large,
        small,
        secondary,
        'active': isActive,
        'disable': disable,
        'closed': isClosed
      }
    );

    return (
      <span
        className={classnames(
          {
            tag: !large && !small,
            p: large || small,
            small: small
          },
          classes
        )}
        onClick={this.handleSelect}
        style={customStyles}
        data-id={id}
      >
        {secondary && icon
          ? <Icon icon={icon.name} type={icon.type}/>
          : null
        }
        {name}
        {withClose &&
          <a
            href="#"
            onClick={this.handleClose}
            data-id={id}
          >
            <Icon icon={'close-10'} type={'other'} />
          </a>
        }
      </span>
    );
  }

  render () {
    return (
      <Fragment>
        {this.renderTag()}
      </Fragment>
    );
  }
}

export default Tag;



// WEBPACK FOOTER //
// ./src/uis/elements/Tags/Tag/Tag.js